export const DEFAULT_REHAB_ID = "miracles_asia_thailand";

const rehabs = [
  {
    id: "miracles_asia_thailand",
    name: "Miracles Asia Thailand",
    country: "Thailand",
    location: "Thailand",
    timezone: "Asia/Bangkok",
    currency: "THB",
  },
  {
    id: "miracles_asia_philippines",
    name: "Miracles Asia Philippines",
    country: "Philippines",
    location: "Philippines",
    timezone: "Asia/Manila",
    currency: "PHP",
  },
];

export function getRehabByClient(client = {}) {
  if (client.rehabId) {
    const rehab = rehabs.find((item) => item.id === client.rehabId);
    if (rehab) return rehab;
  }

  if (client.rehabCountry === "Philippines") {
    return rehabs.find((item) => item.id === "miracles_asia_philippines");
  }

  return rehabs.find((item) => item.id === DEFAULT_REHAB_ID);
}

export default rehabs;
